import { useEffect, useState } from 'react';

/**
 * Page publique de retour après un paiement Stripe (le statut réel arrive par webhook). Le client y voit le nom et le
 * logo de SON entreprise (paramètre `e` ajouté au lien de paiement), jamais ceux d'une autre.
 */
export function PaymentReturnPage() {
  const params = new URLSearchParams(window.location.search);
  const ok = params.get('statut') === 'ok';
  const tenantId = params.get('e');
  const [company, setCompany] = useState<{ name: string; logoUrl: string | null } | null>(null);
  useEffect(() => {
    if (!tenantId || !/^[0-9a-f-]{36}$/i.test(tenantId)) return;
    fetch(`/v1/public/company/${tenantId}`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setCompany, () => undefined);
  }, [tenantId]);
  return (
    <main className="portal payment-return">
      {company?.logoUrl ? (
        <img src={company.logoUrl} alt={company.name} className="portal-logo" />
      ) : (
        company && <p className="portal-company">{company.name}</p>
      )}
      {ok ? (
        <>
          <h1>Merci, votre paiement a bien été transmis</h1>
          <p>
            Vous recevrez la confirmation de votre banque. Votre conseiller est prévenu dès que le paiement
            est validé.
          </p>
        </>
      ) : (
        <>
          <h1>Paiement non effectué</h1>
          <p>
            Aucun montant n’a été débité. Vous pouvez réessayer depuis le lien reçu, ou contacter votre
            conseiller.
          </p>
        </>
      )}
    </main>
  );
}
